/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { useCookieConsent } from "@/hooks/ui/use-cookie-consent";
import Link from "next/link";

export function CookieConsentBanner() {
  const { isPending, grant, deny } = useCookieConsent();

  if (!isPending) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[200] border-t border-border bg-background/95 px-4 py-3 shadow-lg backdrop-blur-sm"
      role="region"
      aria-label="Cookie consent"
    >
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-3 sm:flex-row sm:justify-between">
        <p className="text-sm text-muted-foreground">
          We use cookies for analytics and to improve your experience.{" "}
          <Link href="/cookies" className="underline hover:text-foreground">
            Cookie Policy
          </Link>
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={deny}
            className="rounded-md border border-border px-3 py-1.5 text-sm text-muted-foreground transition-colors hover:bg-muted"
            aria-label="Decline non-essential cookies"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={grant}
            className="rounded-md bg-primary px-3 py-1.5 text-sm text-primary-foreground transition-colors hover:bg-primary/90"
            aria-label="Accept cookies"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
